import { Container, Grid, Flex } from 'theme-ui';
import { GroupContent } from './GroupContent';
import { types } from './utilities';

export function GroupContentContainer({ groups, type, backgroundColor }) {
  if (type === types.PRODUCT_KIT_CARDS) {
    return (
      <Container
        sx={{
          px: ['2.4rem', '4rem'],
          py: ['0 !important'],
          '--horizontal-inset': ['0 !important'],
          pt: ['2.4rem', '3.2rem'],
          position: 'relative',
        }}
      >
        <Grid
          sx={{
            gridTemplateColumns: 'repeat(3, 1fr)',
            colGap: '2.5rem',
            rowGap: ['6.4rem', '9.6rem'],

            '.isFeatured:nth-child(even)': {
              flexDirection: 'row-reverse',
            },
          }}
        >
          {groups?.map((group) => (
            <GroupContent backgroundColor={backgroundColor} key={group.id} group={group} />
          ))}
        </Grid>
      </Container>
    );
  }
  if (type === types.VARIANT_SPOTLIGHTS) {
    return (
      <Flex sx={{ flexDirection: 'column', gap: '2.3rem' }}>
        {groups?.map((group) => (
          <GroupContent key={group.id} group={group} backgroundColor={backgroundColor} />
        ))}
      </Flex>
    );
  }
  return null;
}
